@if ((content && items.length && hasAnyItemWithImage) || client.isCms) {
<div class="w-12 p-t-12-x p-t-12-l p-b-12-x p-b-12-l"
     [class]="content?.styles?.bg ? 'bg-' + content?.styles?.bg : ''">
    <div class="wrap-x wrap-l">
        <ng-container *ifSize="'XL'">
            <!-- 4th item at the top (if exists) -->
            @if (items[3] && !items[3].hidden) {
            <div class="m-b-6"
                 [grid]="3"
                 [gridColumnGap]="2">
                <!-- 4th item image/video - takes 2/3 width -->
                <div class="ratio-16-9"
                     [gridColumn]="2">
                    @if (items[3].image) {
                    <img class="rf z-1"
                         [image]="items[3].image">
                    }
                    @if (items[3].video && items[3].mediaType === 'video') {
                    <vimeo-player class="bg-col-w rf z-2"
                                  [video-url]="items[3].video"
                                  [background]="!items[3].showVideoControlPanel"
                                  [autoplay-in-viewport]="true"
                                  [loop]="true"
                                  [controls]="items[3].showVideoControlPanel" />
                    }
                </div>

                <!-- 4th item copy in right column - takes 1/3 width -->
                <div class="flex flex-middle"
                     [gridColumn]="1">
                    <div class="p-l _word-break">
                        <h3 class="h3"
                            [class]="content?.titleColor || 'col-1'">
                            {{items[3].title}}
                        </h3>

                        <read-more class="block m-t-1 p1"
                                   [ngClass]="content?.descColor || 'col-1'"
                                   [text]="items[3]?.desc"
                                   [limit]="'120'"
                                   readMore="...read more"
                                   readLess="...read less"
                                   [showIcon]="false" />
                    </div>
                </div>
            </div>
            }

            <!-- First 3 items in standard layout -->
            <div [grid]="3"
                 [gridColumnGap]="2">
                @for (item of items.slice(0, 3); track $index) {
                @if (item && !item.hidden) {
                <div class="w-12"
                     [gridColumn]="1">
                    <div class="ratio-1-1">
                        @if (item.image) {
                        <img class="rf z-1"
                             [image]="item.image">
                        }
                        @if (item.video && item.mediaType === 'video') {
                        <vimeo-player class="bg-col-w rf z-2"
                                      [video-url]="item.video"
                                      [background]="!item.showVideoControlPanel"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true"
                                      [controls]="item.showVideoControlPanel" />
                        }
                    </div>
                    @if(visibleItemsCount === 3 || visibleItemsCount === 4){
                    <div class="p-l-2 p-t _word-break">
                        <h3 class="h3"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{item.title}}
                        </h3>

                        <read-more class="block m-t-1 p1"
                                   [ngClass]="content?.descColor || 'col-1'"
                                   [text]="item?.desc"
                                   [limit]="'120'"
                                   readMore="...read more"
                                   readLess="...read less"
                                   [showIcon]="false" />
                    </div>
                    }
                </div>
                }
                }

                <!-- Copy for items when not 3 items in first three positions -->
                @if (visibleItemsInFirstThree !== 3) {
                <div class="w-12 p-b-8 flex flex-column flex-justify-center"
                     [gridColumn]="visibleItemsInFirstThree === 1 ? 2 : 1">
                    @for (item of items.slice(0, 3); track $index) {
                    @if (!item.hidden) {
                    <div class="p-l p-t-6 _word-break">
                        <h3 class="h3"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{item.title}}
                        </h3>

                        @if(visibleItemsCount !== 1){
                        <read-more class="block m-t-1 p1"
                                   [ngClass]="content?.descColor || 'col-1'"
                                   [text]="item?.desc"
                                   [limit]="'120'"
                                   readMore="...read more"
                                   readLess="...read less"
                                   [showIcon]="false" />
                        } @else {
                        <p class="m-t-2 p1"
                           [ngClass]="content?.descColor || 'col-1'"
                           [innerHtml]="item?.desc">
                        </p>
                        }
                    </div>
                    }
                    }
                </div>
                }
            </div>
        </ng-container>

        <ng-container *ifSize="'SM'">
            <!-- 4th item first (if exists) -->
            @if (items[3] && !items[3].hidden) {
            <div class="ratio-16-9">
                @if (items[3].image) {
                <img class="rf z-1"
                     [image]="items[3].image">
                }
                @if (items[3].video && items[3].mediaType === 'video') {
                <vimeo-player class="bg-col-w rf z-2"
                              [video-url]="items[3].video"
                              [background]="!items[3].showVideoControlPanel"
                              [autoplay-in-viewport]="true"
                              [loop]="true"
                              [controls]="items[3].showVideoControlPanel" />
                }
            </div>

            <div class="p-l-2 p-t-2 p-b-2 _word-break">
                <h3 class="h4"
                    [ngClass]="content?.titleColor || 'col-1'">
                    {{items[3].title}}
                </h3>

                <read-more class="block m-t-1 p1"
                           [ngClass]="content?.descColor || 'col-11'"
                           [text]="items[3].desc"
                           [limit]="'77'"
                           readMore="...read more"
                           readLess="...read less"
                           [mobileReadMoreColor]="content?.descColor || 'col-11'"
                           [showIcon]="false" />
            </div>
            }

            @switch (visibleItemsCount) {
            @case (1) {
            <div class="ratio-1-1">
                @if (items[0].image) {
                <img class="rf z-1"
                     [image]="items[0].image">
                }
                @if (items[0].video && items[0].mediaType === 'video') {
                <vimeo-player class="bg-col-w rf z-2"
                              [video-url]="items[0].video"
                              [background]="!items[0].showVideoControlPanel"
                              [autoplay-in-viewport]="true"
                              [loop]="true"
                              [controls]="items[0].showVideoControlPanel" />
                }
            </div>

            <div class="p-l-2 p-t-2 p-b-2">
                <h3 class="h4"
                    [ngClass]="content?.titleColor || 'col-1'">
                    {{items[0].title}}
                </h3>

                <read-more class="block m-t-1 p1 _word-break"
                           [ngClass]="content?.descColor || 'col-11'"
                           [text]="items[0].desc"
                           [limit]="'77'"
                           readMore="...read more"
                           readLess="...read less"
                           [mobileReadMoreColor]="content?.descColor || 'col-11'"
                           [showIcon]="false" />
            </div>
            }

            @default {
            <carousel [slidesPerView]="1.25"
                      [spaceBetween]="15">
                @for (item of (visibleItemsCount === 4 ? items.slice(0, 3) : items); track $index) {
                @if (!item.hidden) {
                <ng-template swiperSlide>
                    <div class="ratio-1-1">
                        @if (item.image) {
                        <img class="rf z-1"
                             [image]="item.image">
                        }
                        @if (item.video && item.mediaType === 'video') {
                        <vimeo-player class="bg-col-w rf z-2"
                                      [video-url]="item.video"
                                      [background]="!item.showVideoControlPanel"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true"
                                      [controls]="item.showVideoControlPanel" />
                        }
                    </div>

                    <div class="p-l-2 p-t p-b _word-break">
                        <h3 class="h4"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{item.title}}
                        </h3>

                        <read-more class="block m-t-2 p1"
                                   [ngClass]="content?.descColor || 'col-11'"
                                   [text]="item.desc"
                                   [limit]="'68'"
                                   readMore="...read more"
                                   readLess="...read less"
                                   [mobileReadMoreColor]="content?.descColor || 'col-11'"
                                   [showIcon]="false" />
                    </div>
                </ng-template>
                }
                }
            </carousel>
            }
            }
        </ng-container>
    </div>
</div>
}